import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-propiedad-industrial',
  templateUrl: './propiedad-industrial.component.html',
  styleUrls: ['./propiedad-industrial.component.scss']
})
export class PropiedadIndustrialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
